import { runInInjectionContext } from '@angular/core';
import {
    CustomInjector,
    EscalationInstanceToken,
    EscalationInterface,
    NotificationDataInstanceToken,
    NotificationDataInterface,
    NotificationModel,
    notificationsUpdated$,
    ConfigInstanceToken,
    ConfigInterface,
} from '@evorait/pace-core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../core/services/eta-alert/alert.service';

export enum DASHBOARD_TAB {
    TODAYS,
    UPCOMING,
    NEW,
}
export class DashboardModel {
    public todaysAssignments: NotificationModel[];
    public upcomingAssignments: NotificationModel[];
    public newAssignments: NotificationModel[];

    private notificationsUpdated: Subscription;

    private notificationService: NotificationDataInterface;
    private escalationService: EscalationInterface;
    private alertService: AlertService;
    private configService: ConfigInterface;
    public constructor() {
        const injector = CustomInjector.getInjector();
        this.notificationService = injector.get(NotificationDataInstanceToken);
        this.escalationService = injector.get(EscalationInstanceToken);
        this.alertService = injector.get(AlertService);
        this.configService = injector.get(ConfigInstanceToken);
        // The model is built with `new`, so the stream — which resolves its source through
        // `inject()` — has to be assembled in the injector's context explicitly.
        this.notificationsUpdated = runInInjectionContext(injector, notificationsUpdated$).subscribe(() =>
            this.updateNotifications(),
        );

        this.updateNotifications();
    }

    private updateNotifications(): void {
        this.todaysAssignments = this.notificationService.getTodaysNotifications();
        this.upcomingAssignments = this.notificationService.getUpcomingNotifications();
        this.newAssignments = this.notificationService.getNewNotifications();

        // check if any notification is in progress and set the timer accordingly to raise the escalation alert
        this.escalationService.checkEscalationRequired();
        if (this.configService.getDisplayEtaAlert()) {
            this.alertService.checkEtaAlertRequired();
        }
    }

    /**
     * De-register event listeners on rootScope
     */
    public destroy(): void {
        if (typeof this.notificationsUpdated !== 'undefined') {
            this.notificationsUpdated.unsubscribe();
        }
    }
}
